<template>
  <appbar-view />
  
  <div class="bg-grey-lighten-4 home-scroll-container" v-if="!isLoading">

    <v-navigation-drawer v-model="drawer" temporary density="compact" style="padding-top: 56px" class="elevation-5">
      <v-list>
        <v-list-item link to="/home" @click="closeDrawer">
          <template #prepend>
            <v-avatar size="28" class="mr-2">
              <v-img src="https://tse2.mm.bing.net/th/id/OIP.MS5OosTTRq5tUOV31w9EEAHaHa?cb=12&rs=1&pid=ImgDetMain&o=7&rm=3" />
            </v-avatar>
          </template>
          <v-list-item-title class="font-weight-bold">Inicio</v-list-item-title>
        </v-list-item>

        <v-list-item link to="/pedidos" @click="closeDrawer">
          <template #prepend>
            <v-avatar size="28" class="mr-2">
              <v-img src="https://static.vecteezy.com/system/resources/previews/012/714/703/original/carton-box-icon-and-illustration-vector.jpg" />
            </v-avatar>
          </template>
          <v-list-item-title>Pedidos</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="user.email === 'jorgepenagos50@gmail.com'" link to="/dashboard-admin" @click="closeDrawer">
           <template #prepend><v-icon class="mr-2">mdi-view-dashboard</v-icon></template>
           <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>

        <v-list-item link to="/user-info" @click="closeDrawer">
          <template #prepend>
            <v-avatar size="28" class="mr-2">
              <v-img src="https://img.icons8.com/emoji/48/bust-in-silhouette.png" />
            </v-avatar>
          </template>
          <v-list-item-title>Usuario</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2" />
        <v-list-item link @click="cerrarSesion">
          <template #prepend>
            <v-avatar size="28" class="mr-2">
              <v-img src="https://cdn-icons-png.flaticon.com/512/6811/6811880.png" />
            </v-avatar>
          </template>
          <v-list-item-title>Salir</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2" />
        <v-list-item link to="/aviso-privacidad">
           <template #prepend><v-icon class="mr-2">mdi-shield-check</v-icon></template>
           <v-list-item-title>Aviso de privacidad</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-btn
      icon
      rounded="e-xl"
      color="orange-darken-3"
      class="drawer-toggle-btn elevation-4"
      @click="drawer = !drawer"
      style="position: fixed; top: 110px; left: 0; z-index: 100;"
    >
        <v-icon color="white">{{ drawer ? 'mdi-close' : 'mdi-menu' }}</v-icon>
    </v-btn>

    <v-sheet class="mb-4 pb-2 position-relative" style="border-bottom-left-radius: 20px; border-bottom-right-radius: 20px; overflow: hidden;" elevation="1">
        <v-carousel cycle :hide-delimiters="false" :show-arrows="false" height="200" interval="5000" hide-delimiter-background>
          <v-carousel-item v-for="(image, index) in bannerImages" :key="`banner-${index}`">
            <v-img :src="image" height="100%" class="align-center" :cover="false"></v-img>
          </v-carousel-item>
        </v-carousel>

        <v-sheet class="px-4 mt-4" color="transparent">
             <v-sheet class="d-flex overflow-x-auto pb-2" color="transparent" style="gap: 16px; scrollbar-width: none;">
                <v-sheet v-for="brand in brandList" :key="brand.name" 
                     class="d-flex flex-column align-center flex-shrink-0"
                     color="transparent"
                     @click="toggleBrandFilter(brand.name)"
                     style="cursor: pointer;">
                  <v-avatar size="60" :class="selectedBrand === brand.name ? 'active-brand' : 'inactive-brand'">
                    <v-img :src="brand.image" :cover="false"></v-img>
                  </v-avatar>
                  <span class="text-caption mt-1 text-truncate text-center" 
                        :class="selectedBrand === brand.name ? 'text-blue-darken-4 font-weight-bold' : 'text-grey-darken-1'"
                        style="width: 60px;">
                    {{ brand.name }}
                  </span>
                </v-sheet>
            </v-sheet>
        </v-sheet>
    </v-sheet>


    <v-sheet class="py-3 mb-4 mx-2" elevation="6" rounded="xl" 
         style="background: linear-gradient(135deg, #0D47A1 0%, #1976D2 50%, #42A5F5 100%); border: 1px solid #64B5F6;"> 
    
    <v-sheet class="px-4 mb-2 d-flex align-center justify-space-between" color="transparent">
        <v-sheet color="transparent" class="d-flex align-center">
            <v-avatar color="white" size="32" class="mr-2 elevation-2">
                <v-icon color="blue-darken-4" size="18">mdi-fire</v-icon>
            </v-avatar>
            <h2 class="text-subtitle-1 font-weight-black text-white">Más Vendidos</h2>
        </v-sheet>
        <v-chip color="white" variant="flat" size="x-small" class="font-weight-black text-blue-darken-4">
            {{ filteredPromotions.filter(p => p.id === 148 || p.sublinea_prod_id === 'REDBULL').length }} Disponibles
        </v-chip>
    </v-sheet>

    <v-slide-group show-arrows="always" class="pa-0">
        <v-slide-group-item v-for="promo in filteredPromotions.filter(p => p.id === 148 || p.sublinea_prod_id === 'REDBULL')" :key="'vende-' + promo.id">
            <v-card width="155" class="ma-1 flex-shrink-0 position-relative" rounded="lg" elevation="4" @click="addToCart(promo)">
                <v-sheet v-if="promo.promo_price" color="red-accent-4" class="position-absolute px-2 py-0 rounded-be-xl text-white font-weight-black" style="top: 0; left: 0; z-index: 3; font-size: 10px;">
                    -{{ promo.promo_price }}%
                </v-sheet>

                <v-sheet class="pa-2 d-flex justify-center align-center bg-white" height="100">
                    <v-img :src="promo.foto" height="85%" contain></v-img>
                </v-sheet>

                <v-sheet class="pa-2 bg-white">
                    <div class="text-caption text-grey-darken-3 text-truncate font-weight-bold mb-1">{{ promo.nombre }}</div>
                    
                    <v-sheet class="d-flex align-center flex-wrap mb-1" color="transparent" style="gap: 4px;">
                        <span class="text-subtitle-1 font-weight-black text-blue-darken-4">
                            ${{ parseFloat(getPrecioFinal(promo)).toFixed(2) }}
                        </span>
                        <span v-if="promo.promo_price" class="text-caption text-grey text-decoration-line-through" style="font-size: 0.7rem !important;">
                            ${{ parseFloat(promo.price).toFixed(2) }}
                        </span>
                    </v-sheet>

                    <v-btn block color="blue-darken-4" size="x-small" rounded="pill" class="text-none font-weight-black">AGREGAR</v-btn>
                </v-sheet>
            </v-card>
        </v-slide-group-item>
    </v-slide-group>
</v-sheet>


<v-sheet class="py-3 mb-4 mx-2" elevation="1" rounded="xl" border style="border-left: 6px solid #FF6D00;"> 
    <v-sheet class="px-4 mb-2 d-flex align-center justify-space-between" color="transparent">
        <v-sheet color="transparent" class="d-flex align-center">
            <v-icon color="orange-darken-4" size="24" class="mr-2">mdi-tag-heart</v-icon>
            <h2 class="text-subtitle-2 font-weight-black text-grey-darken-4">Exclusivos Nissin</h2>
        </v-sheet>
    </v-sheet>

    <v-slide-group show-arrows="always" class="pa-0">
        <v-slide-group-item v-for="promo in filteredPromotions.filter(p => p.id === 17 || p.linea_prod_id?.includes('NISSIN'))" :key="'exclu-' + promo.id">
            <v-card width="150" class="ma-1 flex-shrink-0" rounded="lg" border elevation="0" @click="addToCart(promo)">
                <v-sheet class="pa-2 d-flex justify-center align-center bg-grey-lighten-5" height="90">
                    <v-img :src="promo.foto" height="85%" contain></v-img>
                </v-sheet>
                <v-sheet class="pa-2" color="white">
                    <div class="text-caption text-truncate font-weight-bold text-grey-darken-2">{{ promo.nombre }}</div>
                    
                    <v-sheet class="d-flex align-center flex-wrap mt-1" color="transparent" style="gap: 4px;">
                        <span class="text-subtitle-2 font-weight-black text-orange-darken-4">
                            ${{ parseFloat(getPrecioFinal(promo)).toFixed(2) }}
                        </span>
                        <span v-if="promo.promo_price" class="text-caption text-grey text-decoration-line-through" style="font-size: 0.65rem !important;">
                            ${{ parseFloat(promo.price).toFixed(2) }}
                        </span>
                    </v-sheet>

                    <v-btn block color="orange-darken-4" size="x-small" variant="flat" class="mt-2 text-white font-weight-bold">AGREGAR</v-btn>
                </v-sheet>
            </v-card>
        </v-slide-group-item>
    </v-slide-group>
</v-sheet>


    <v-sheet class="px-2" color="transparent">
        <PromocionRegaloView />
    </v-sheet>

    <v-sheet class="py-4 mt-4 bg-white">
         <v-sheet class="text-center mb-2" color="transparent">
             <span class="text-overline text-grey">Marcas Oficiales</span>
         </v-sheet>
         <v-carousel cycle :hide-delimiters="true" :show-arrows="false" height="60" interval="2500" hide-delimiter-background>
            <v-carousel-item v-for="(item, idx) in transitions" :key="idx">
                <v-sheet class="d-flex justify-center align-center fill-height" color="transparent">
                    <v-img :src="item.image" max-width="120" max-height="50" contain></v-img>
                </v-sheet>
            </v-carousel-item>
         </v-carousel>
    </v-sheet>

    <v-sheet class="px-4 pb-16 mb-16" color="transparent">
        <v-card class="pa-4 bg-blue-darken-4 text-white rounded-xl mt-6" elevation="4">
            <v-sheet class="d-flex align-center justify-space-between" color="transparent">
                <v-sheet color="transparent">
                    <div class="text-subtitle-1 font-weight-bold">¿Necesitas Ayuda?</div>
                    <div class="text-caption opacity-80">Contáctanos por WhatsApp</div>
                </v-sheet>
                <v-btn icon color="green" size="large" class="elevation-4" href="https://wa.link/plk405" target="_blank">
                     <v-icon color="white" size="28">mdi-whatsapp</v-icon>
                </v-btn>
            </v-sheet>
        </v-card>
    </v-sheet>

    <v-snackbar v-model="snackbar" :timeout="1500" location="top" color="green-darken-1" rounded="pill" elevation="8">
      <v-sheet class="d-flex align-center justify-center" color="transparent">
         <v-icon start icon="mdi-check-circle" color="white"></v-icon>
         <span class="font-weight-bold">{{ snackbarText }}</span>
      </v-sheet>
    </v-snackbar>

    <CartDialog v-model="cartDialog" />

    <v-btn icon color="blue-darken-4" @click="openCart" elevation="10" 
           style="position: fixed; right: 20px; bottom: 100px; z-index: 2000; width: 60px; height: 60px;">
        <v-icon color="white" size="28">mdi-cart-outline</v-icon>
        <v-sheet v-if="totalCajas > 0" 
                 color="red" 
                 class="position-absolute d-flex align-center justify-center rounded-circle text-caption font-weight-bold text-white" 
                 style="top: 0; right: 0; width: 22px; height: 22px;">
            {{ totalCajas }}
        </v-sheet>
    </v-btn>

    <bottom-navigation />
  </div>
</template>

<style scoped>
/* Estilos necesarios para los estados visuales (Active/Inactive) */
.active-brand {
    border: 2px solid #1565C0;
    transform: scale(1.05);
    transition: all 0.3s ease;
}

.inactive-brand {
    border: 2px solid #e0e0e0;
    background-color: white;
    transition: all 0.3s ease;
}

/* Animación Fuego */
.animate-flicker { animation: flicker 2s infinite; }
@keyframes flicker {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.8; transform: scale(1.1); }
}

/* Estilo para ocultar scrollbars en navegadores webkit pero permitir scroll */
.v-sheet::-webkit-scrollbar {
    display: none;
}

.home-scroll-container {
  height: calc(100vh - (64px + env(safe-area-inset-top, 30px)));
  overflow-y: auto;
  padding-bottom: 80px; /* Espacio para que el último elemento no quede tapado por el menú inferior */
  -webkit-overflow-scrolling: touch;
}
</style>
<script>
import axios from "axios";
import AppbarView from "./appbar/appbarView.vue";
import CartDialog from "./Administrador/CarritoViewStore.vue";
import { inject, computed, ref, onMounted, onBeforeUnmount } from "vue";
import { useUserStore } from "@/stores/userStore";
import BottomNavigation from "./submenu/BottomNavigation.vue";
import PromocionRegaloView from "./Promociones/PromocionRegaloView.vue";
import { useRouter } from "vue-router";
import { App } from '@capacitor/app';

export default {
  name: "HomeView",
  components: { BottomNavigation, AppbarView, CartDialog, PromocionRegaloView },

  setup() {
    const router = useRouter();
    const cartStore = inject("cartStore");
    const userStore = useUserStore();

    // 1. VARIABLES REACTIVAS
    const isLoading = ref(true);
    const drawer = ref(false);
    const cartDialog = ref(false);
    const snackbar = ref(false);
    const snackbarText = ref("");
    
    let backButtonListener = null;
    let promotionsInterval = null;

    const user = ref({});
    const promotions = ref([]);
    const promoGifts = ref([]);
    const searchQuery = ref("");
    const selectedBrand = ref(null);
    const brandList = ref([]);
    
    // Carrito
    const cart = ref(JSON.parse(localStorage.getItem("cart")) || []);

    // Datos estáticos
    const bannerImages = ref([
      "https://grupomv.mx/images/redbullsuper%20(compress).png",
      "https://m.media-amazon.com/images/I/81a5BpHLgoL.jpg",
      "https://grupomv.mx/images/sabores.webp",
      "https://grupomv.mx/images/suprematostadas1.jpg",
      "https://m.media-amazon.com/images/I/61HjQDBJqRL.jpg"
    ]);

    const transitions = ref([
      { image: "https://www.penafiel.com/wp-content/themes/penafiel/images/penafiel-logo.png" },
      { image: "https://pngimg.com/uploads/red_bull/red_bull_PNG24.png" },
      { image: "https://cdn.uc.assets.prezly.com/8b851933-e208-4958-8d79-8bc2feebea74/-/resize/992/-/format/png/" },
      { image: "https://www.boones.mx/assets/images/logo-boones.png" },
      { image: "https://logos-world.net/wp-content/uploads/2021/09/Jack-Daniels-Logo.png" },
      { image: "https://grupomv.mx/images/logos/4.png" },
    ]);

    // 2. FUNCIONES Y COMPUTADOS
    
    // Wrapper para addToCart y mostrar snackbar si es necesario
    const addToCart = (item) => {
        cartStore.addToCart(item);
        snackbarText.value = "Producto agregado";
        snackbar.value = true;
    };

    async function cerrarSesion() {
      await userStore.logout();
      router.replace("/");
    }

    function closeDrawer() {
      drawer.value = false;
    }

    function openCart() {
      cartDialog.value = true;
    }

    const totalCajas = computed(() => {
      return cartStore?.state.cart.reduce((t, item) => t + item.quantity, 0) || 0;
    });

    const filteredPromotions = computed(() => {
      let result = promotions.value;
      if (selectedBrand.value) {
        result = result.filter(p => p.sublinea === selectedBrand.value);
      }
      if (searchQuery.value) {
        result = result.filter(p => p.nombre.toLowerCase().includes(searchQuery.value.toLowerCase()));
      }
      // Normalizamos la data al vuelo para visualización
      return result.map(p => normalizarPromo(p));
    });

    function normalizarPromo(promo) {
      const precioFinalVenta = Number(promo.precio_mostrador ?? promo.price);
      const promoPercent = Number(promo.promo_price ?? 0);
      const precioConPromo = promo.id_promocion && promoPercent > 0
          ? Number((precioFinalVenta * (1 - promoPercent / 100)).toFixed(2))
          : precioFinalVenta;

      return {
        ...promo,
        price: precioFinalVenta, // Precio original (tachado)
        precio_final: precioConPromo, // Precio con descuento
        promo_percent: promoPercent,
        promoUnico: true,
        iva: Number(promo.iva16 ?? 0),
        ieps: Number(promo.ieps ?? 0),
      };
    }
    
    // Helper para obtener el precio a mostrar en la tarjeta
    const getPrecioFinal = (promo) => {
        return promo.precio_final || promo.price;
    }

    async function fetchPromotions() {
      const cacheKey = "promotionsCacheMain";
      const cacheTimeKey = cacheKey + "_time";
      const cache = localStorage.getItem(cacheKey);
      const cacheTime = Number(localStorage.getItem(cacheTimeKey));
      const now = Date.now();
      const cacheDuration = 5 * 60 * 1000; 
      const token = userStore.token || localStorage.getItem("token");

      const isPromotionActive = (promo) => {
        if (!promo.fecha_fin) return false;
        const fechaFin = new Date(promo.fecha_fin).getTime();
        return fechaFin >= Date.now();
      };

      if (cache && cacheTime && now - cacheTime < cacheDuration) {
        const cachedPromos = JSON.parse(cache).filter(isPromotionActive);
        promotions.value = cachedPromos;
        extractBrands(cachedPromos);
        isLoading.value = false; // ✅ Datos listos, mostrar UI
        return;
      }

      try {
        const { data } = await axios.get(
          "https://mvexpress.mx/api/promotions/promo-app",
          { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
        );
        const activePromotions = data.filter(isPromotionActive);
        promotions.value = activePromotions;
        extractBrands(activePromotions);
        
        localStorage.setItem(cacheKey, JSON.stringify(activePromotions));
        localStorage.setItem(cacheTimeKey, now.toString());
      } catch (e) {
        console.error("Error al obtener promociones:", e);
        // 🔥 Si el token es inválido (401) o prohibido (403), forzar logout
        if (e.response && (e.response.status === 401 || e.response.status === 403)) {
          localStorage.removeItem("token"); // Limpieza extra de seguridad
          localStorage.removeItem("user");
          await userStore.logout();
          router.replace("/");
          return; // Detener ejecución
        }
      } finally {
        isLoading.value = false; // ✅ Termina carga (éxito o error controlado)
      }
    }

    function extractBrands(promoList) {
      const uniqueBrands = new Map();
      promoList.forEach(p => {
        if (p.sublinea && !uniqueBrands.has(p.sublinea)) {
          uniqueBrands.set(p.sublinea, p.foto || 'https://grupomv.mx/images/logo2.png');
        }
      });
      brandList.value = Array.from(uniqueBrands, ([name, image]) => ({ name, image }));
    }

    async function fetchPromoGifts() {
        // ... (Tu lógica existente para regalos)
    }

    function toggleBrandFilter(brandName) {
      selectedBrand.value = selectedBrand.value === brandName ? null : brandName;
    }

    // 3. LIFECYCLE HOOKS
    onMounted(async () => {
      // 🔒 Validación de seguridad: Si no hay token, mandar al login
      if (!userStore.token) {
        await userStore.logout();
        router.replace("/");
        return;
      }

      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        user.value = JSON.parse(storedUser);
      }
      fetchPromotions();
      fetchPromoGifts();
      promotionsInterval = setInterval(fetchPromotions, 5 * 60 * 1000);

      // Listener botón físico
      backButtonListener = await App.addListener('backButton', () => {
        if (drawer.value) { drawer.value = false; return; }
        if (cartDialog.value) { cartDialog.value = false; return; }

        const currentPath = router.currentRoute.value.path;
        if (currentPath === '/home' || currentPath === '/') {
          App.minimizeApp();
        } else {
          router.back();
        }
      });
    });

    onBeforeUnmount(() => {
      if (promotionsInterval) clearInterval(promotionsInterval);
      if (backButtonListener) backButtonListener.remove();
    });

    return {
      isLoading,
      bannerImages,
      transitions,
      promotions,
      promoGifts,
      searchQuery,
      snackbar,
      snackbarText,
      cartDialog,
      cart,
      addToCart,
      filteredPromotions,
      totalCajas,
      openCart,
      drawer,
      cerrarSesion,
      closeDrawer,
      user,
      brandList,
      selectedBrand,
      toggleBrandFilter,
      getPrecioFinal
    };
  },
};
</script>